import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseI } from 'app/core/models/response';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

const apiUrl = environment.API_URI;

@Injectable({
  providedIn: 'root'
})
export class HotelServices {

  constructor(private http: HttpClient) { }

  addHotel(data): Observable<ResponseI> {
    return this.http.post<ResponseI>(`${apiUrl}/hotel`, data);
  }

  getHotels() {
    return this.http.get(`${apiUrl}/hotel`);
  }

  findHotelByAdminId(id) {
    return this.http.get(`${apiUrl}/hotel/admin/${id}`);
  }

  getOneHotel(id) {
    return this.http.get(`${apiUrl}/hotel/${id}`);
  }

  editHotel(id, data) {
    return this.http.put(`${apiUrl}/hotel/${id}`, data);
  }

  deleteHotel(id) {
    return this.http.delete(`${apiUrl}/hotel/${id}`);
  }

  getHotelByAdmin(id) {
    return this.http.get(`${apiUrl}/hotel-admin/${id}`)
  }

}
